import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TableActionComponent } from '../table-action';

@Component({
  selector: 'wo-view-table-action',
  templateUrl: './view-table-action.component.html',
  styleUrls: [ './view-table-action.component.scss' ],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TableActionComponent,
  ],
})
export class ViewTableActionComponent {}
